import { client } from '../api/client';
import { getPosition } from '../api/mobile';

export const EVENTS = {
    LOGIN_OK: 'LO',
    OPEN_POI: 'OP',
    WRITE_REVIEW: 'WR',
    SET_NAVIGATION_TO_POI: 'SN',
    PHONE_CALL: 'PC',
    SEND_PHOTO: 'SP',
    SEND_EVALUATION: 'SE'
};
export async function logEvent(type, profileId = null, placeId = null) {
    const url = `/set_event_new/${type}/${profileId}/${placeId || ''}`;
    const position = await getPosition();
    let postData = {};
    postData.lat = position.lat;
    postData.lon = position.lng;
    
    if(isNaN(profileId)) {
        postData.email = profileId;
    } 
    client.post(url, postData);
}